export const siteContact = {
  phone: "+91-9217951119",
  email: "kartikeya@namespaceconsultants.com",
  address: {
    line1: "PT-62/3, L.G.F., PT And DD Block,",
    line2: "Kalkaji, New Delhi, 110019",
    full: "PT-62/3, L.G.F., PT And DD Block, Kalkaji, New Delhi, 110019",
  },
};
